<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "EmpfehlungNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="12"></NewArticle>
</template>

<style scoped>

</style>
